import React, {useEffect, useState} from "react";
import {useFiltered} from "@atttomyx/shared-hooks";
import {IconButton, Typography} from "@mui/material";
import {Delete as DeleteIcon, Edit as EditIcon} from "@mui/icons-material";
import {Cards, ConfirmDeleteDialog, FiltersAccordion, FloatingAddButton} from "@atttomyx/react-components";
import {WordFilters} from "../filters";
import {WordCard} from "../cards";
import {WordDialog} from "../dialogs";
import {internalDictionaryService} from "../../services";
import {dictionaryUtils} from "../../utils";

const DictionaryPage = (props) => {
    const { snackbar, dimensions, words, filters, onSave, onDelete } = props;
    const [ word, setWord ] = useState(null);
    const [ showEdit, setShowEdit ] = useState(false);
    const [ showDelete, setShowDelete ] = useState(false);
    const [ showFilters, setShowFilters ] = useState(false);

    const filtered = useFiltered(words, filters, dictionaryUtils.sortByWord);

    useEffect(() => {
        if (!word) {
            setShowEdit(false);
            setShowDelete(false);
        }
    }, [word]);

    return <div className="dictionary-page">
        <Typography variant="h5" paragraph={true}>
            Dictionary
        </Typography>
        <div className="field">
            <FiltersAccordion
                filters={filters}
                form={WordFilters}
                open={showFilters}
                onOpen={() => setShowFilters(true)}
                onClose={() => setShowFilters(false)}
            />
        </div>
        <Cards
            items={filtered}
            paging={filters.paging}
            dimensions={dimensions}
            renderer={(word) =>
                <WordCard key={word.word} word={word}>
                    <IconButton
                        color="secondary"
                        title="Delete"
                        className="delete"
                        onClick={() => {
                            setWord(word);
                            setShowDelete(true);
                        }}
                    >
                        <DeleteIcon/>
                    </IconButton>
                    <IconButton
                        color="primary"
                        title="Edit"
                        onClick={() => {
                            setWord(word);
                            setShowEdit(true);
                        }}
                    >
                        <EditIcon/>
                    </IconButton>
                </WordCard>}
        />
        <FloatingAddButton
            title="Add word"
            position={!dimensions.landscape || !dimensions.short ? "higher" : undefined}
            center={dimensions.landscape && !dimensions.short}
            onClick={() => {
                setWord({});
                setShowEdit(true);
            }}
        />
        {showEdit && word ? <WordDialog
            snackbar={snackbar}
            word={word}
            onCancel={() => {
                setShowEdit(false);
                setWord(null);
            }}
            onSave={(saved) => {
                setShowEdit(false);
                setWord(null);
                onSave(saved);
            }}
        /> : null}
        {showDelete && word ? <ConfirmDeleteDialog
            snackbar={snackbar}
            title={word.word}
            onCancel={() => {
                setShowDelete(false);
                setWord(null);
            }}
            onDelete={(adId) => {
                setShowDelete(false);
                setWord(null);
                onDelete(adId);
            }}
            deleter={(success, failure) => internalDictionaryService.deleteWord(word.word, success, failure)}
        /> : null}
    </div>
}

export default DictionaryPage;
